var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path === '/bulk') ? [_c('BulkUploadForm')] : _vm._e(), _vm._v(" "), (_vm.$route.path === '/bulk/review') ? [_c('ReviewBulkUpload')] : _vm._e(), _vm._v(" "), (_vm.$route.path === '/bulk/payment') ? [_c('BulkPayment')] : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-644817f7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/Pages/BulkUpload/BulkUpload.vue
// module id = DAkp
// module chunks = 2